const ContactCard=({icon,title,subTitle,body})=>{
    return <div  className="group text-center flex items-center flex-col max-w-[70%] md:max-w-[13em] font-noto">
        <img src={icon} alt="contact card icon" className="w-8 h-8 mb-3 group-hover:animate-bounce" />
        <h2 className="text-3xl">{title}</h2>
        <h5 className="text-sm mb-2">{subTitle}</h5>
        <p className="text-base">{body}</p>
    </div>
}
export default ContactCard;